import React, { useReducer, useContext, createContext } from "react";
import { FILTERS } from "../utils/constants/FILTERS";

const initialState = {
  deals: [],
  dealHeaders: [],
  dealRows: [],
  dealsFiltered: [],
  filtersList: [],
  quickFilters: [],
  isLoading: false,
  condition: null,
  refetchDeals: false,
};

export const ACTIONS = {
  SET_DEALS: "SET_DEALS",
  SET_VALUE: "SET_VALUE",
  SET_FILTERS_LIST: "SET_FILTERS_LIST",
  SET_QUICK_FILTERS: "SET_QUICK_FILTERS",
  SET_IS_LOADING: "SET_IS_LOADING",
  SET_CONDITION: "SET_CONDITION",
  REFETCH_DEALS: "REFETCH_DEALS",
};

const NULL_OPS = new Set(["is empty", "is not empty"]);
const STRING_OPS = new Set(["contains", "does not contain", "starts with", "ends with"]);

// Values the API stores as 1/0 but which filters express as "true"/"false"
const BOOL_WORD = new Set(["true", "false"]);
const BOOL_TRUTHY = new Set(["true", "1"]);
const BOOL_CELL_LIKE = new Set(["true", "false", "1", "0"]);

const applyFilterFn = (row, f) => {
  const cell = row[f.label];
  if (NULL_OPS.has(f.operator)) {
    return FILTERS[f.operator](cell, f.value);
  }
  if (STRING_OPS.has(f.operator)) {
    return FILTERS[f.operator](
      String(cell ?? "").toLowerCase(),
      String(f.value ?? "").toLowerCase()
    );
  }
  const numA = Number(cell);
  const numB = Number(f.value);
  if (f.value !== "" && !isNaN(numA) && !isNaN(numB)) {
    return FILTERS[f.operator](numA, numB);
  }
  const normCell = String(cell ?? "").toLowerCase();
  const normValue = String(f.value ?? "").toLowerCase();
  // Normalize 1/0/"True"/"False" to boolean when the filter value is "true" or "false"
  if (BOOL_WORD.has(normValue) && BOOL_CELL_LIKE.has(normCell)) {
    return FILTERS[f.operator](BOOL_TRUTHY.has(normCell), BOOL_TRUTHY.has(normValue));
  }
  return FILTERS[f.operator](normCell, normValue);
};

const computeFiltered = (rows, filtersList, quickFilters) => {
  const allFilters = [...filtersList, ...quickFilters];
  if (allFilters.length === 0) return [];
  let result = rows;
  allFilters.forEach((f) => {
    result = result.filter((d) => {
      try {
        return applyFilterFn(d, f);
      } catch {
        return false;
      }
    });
  });
  return result;
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_DEALS:
      const dealsFlat = action.payload.flat();
      const headers = Object.keys(dealsFlat[0] || [])?.map((key) => ({
        id: key,
        label: key.replace(/[_]/g, " "),
      }));
      const rows = [...dealsFlat];

      return {
        ...state,
        deals: action.payload,
        dealHeaders: headers,
        dealRows: rows,
      };
    // case ACTIONS.SET_VALUE:
    //   const index = action.payload.index;
    //   console.log("index", index);
    //   const value = action.payload.value;
    //   console.log("value", value);
    //   const field = action.payload.field;
    //   console.log("field", field);

    //   const newDeals = [...state.deals.flat()];
    //   console.log("newDeals", newDeals);
    //   const newDeal = newDeals.find((d, dIndex) => dIndex === index);
    //   console.log("newDeal", newDeal);
    //   newDeal[field] = value;

    //   newDeals.splice(index, 1, newDeal);
    //   return {
    //     ...state,
    //     deals: newDeals,
    //   };
    case ACTIONS.SET_FILTERS_LIST:
      return {
        ...state,
        filtersList: action.payload,
        dealsFiltered: computeFiltered(state.dealRows, action.payload, state.quickFilters),
      };
    case ACTIONS.SET_QUICK_FILTERS:
      return {
        ...state,
        quickFilters: action.payload,
        dealsFiltered: computeFiltered(state.dealRows, state.filtersList, action.payload),
      };
    case ACTIONS.SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case ACTIONS.SET_CONDITION:
      return {
        ...state,
        condition: action.payload,
      };
    case ACTIONS.REFETCH_DEALS:
      return {
        ...state,
        refetchDeals: action.payload,
      };
    default:
      return state;
  }
};

const DealsContext = createContext(initialState);

export default function DealsProvider({ children }) {
  return (
    <DealsContext.Provider value={useReducer(reducer, initialState)}>
      {children}
    </DealsContext.Provider>
  );
}

export const useDealsContext = () => useContext(DealsContext);
